import { UIElement } from "./ui_element.js";
import { ImgID } from "../../image_loader/img_id.js";
import { ImagesHolder } from "../../image_loader/images_holder.js";
import { TransformOptions } from "./ui_element.js";

export class UITileImage extends UIElement
{
  private image: ImageBitmap;
  private img_id: ImgID;
  private pattern: CanvasPattern | null = null;

  private tile_size: number;
  private repeat_step: number;

  constructor(
    ctx: CanvasRenderingContext2D,
    x: number,
    y: number,
    width: number,
    height: number,
    image_id: ImgID,
    tile_size: number,
    options?: TransformOptions,
    is_scalable_on_click = false
  )
  {
    super( ctx, x, y, width, height, false, is_scalable_on_click, options );
    this.img_id = image_id;
    this.image = ImagesHolder.getImage( image_id );
    this.tile_size = tile_size;
    this.repeat_step = tile_size;
    this.createPattern();
    this.healWhenLoaded();
  }

  private healWhenLoaded(): void
  {
    if ( !ImagesHolder.isPlaceholder( this.image ) )
      return;
    const id = this.img_id;
    ImagesHolder.whenLoaded( id, bmp =>
    {
      if ( this.img_id !== id || !ImagesHolder.isPlaceholder( this.image ) )
        return;
      this.image = bmp;
      this.createPattern();
      this.setShouldBeRendered();
    } );
  }

  name(): string { return "UITileImage"; }

  private createPattern()
  {
    this.pattern = this.ctx.createPattern( this.image, "repeat" );

    if ( !this.pattern ) return;

    const scale = this.tile_size / this.image.width;

    this.pattern.setTransform(
      new DOMMatrix().scale( scale, scale )
    );
  }

  public settile_size( size: number )
  {
    if ( this.repeat_step === this.tile_size )
      this.repeat_step = size;
    this.tile_size = size;
    this.createPattern();
    this.setShouldBeRendered();
  }

  public setRepeatStep( step: number ): void
  {
    this.repeat_step = Math.max( 1, step );
    this.setShouldBeRendered();
  }

  private drawRepeatedImages( image: CanvasImageSource, width: number ): void
  {
    const tile_height = this.tile_size * this.image.height / this.image.width;
    for ( let tile_x = 0; tile_x < width; tile_x += this.repeat_step )
      this.ctx.drawImage( image, tile_x, 0, this.tile_size, tile_height );
  }

  public setImageId( image_id: ImgID ): void
  {
    this.img_id = image_id;
    this.image = ImagesHolder.getImage( image_id );
    this.createPattern();
    this.healWhenLoaded();
    this.setShouldBeRendered();
  }

  render(): void
  {
    if ( !this.shouldBeRendered() || !this.pattern )
      return;

    this.startRender();
    this.applyTransform();

    const w = this.rect.getW();
    const h = this.rect.getH();

    this.ctx.save();
    this.ctx.translate( -this.rect.getW2(), -this.rect.getH2() );

    if ( this.darkness_factor === 0 )
    {
      if ( this.repeat_step === this.tile_size )
      {
        this.ctx.fillStyle = this.pattern;
        this.ctx.fillRect( 0, 0, w, h );
      }
      else
      {
        this.ctx.beginPath();
        this.ctx.rect( 0, 0, w, h );
        this.ctx.clip();
        this.drawRepeatedImages( this.image, w );
      }
    }
    else
    {
      const dark = this.createDarkenedImage( this.image );
      if ( this.repeat_step !== this.tile_size )
      {
        this.ctx.beginPath();
        this.ctx.rect( 0, 0, w, h );
        this.ctx.clip();
        this.drawRepeatedImages( dark, w );
      }
      else
      {
        const dark_pattern = this.ctx.createPattern( dark, "repeat" );
        if ( dark_pattern )
        {
          const scale = this.tile_size / this.image.width;
          dark_pattern.setTransform( new DOMMatrix().scale( scale, scale ) );
          this.ctx.fillStyle = dark_pattern;
          this.ctx.fillRect( 0, 0, w, h );
        }
      }
    }

    this.ctx.restore();
    this.finishRender();
  }
}
